module.exports = __webpack_public_path__ + "img/Intersect.416c658a.png";